var c3site = {
	'getPathUrl': window.location.pathname, 
	'setup': {
		'useExponentialSlider': false,
		'filterTransforms': {
			'fuelEfficiency': ['','A','B','C','D','E','F','G'],
			'grip': ['','A','B','C','D','E','F','G']
		}
	},
	'l10n': {
		'cartAdded': "Produkt bol pridaný do košíka",
		'inCart' : "v košíku",
		'compareAdded' : "Produkt bol pridaný do porovnávača",
		'compareEmpty' : "Porovnávač je prázdny",
		'compareAddProducts' : "Pridajte produkty na porovnanie"
	},
	'pageData': {
		'sort': "top",
		'filter_extra': "",
		'price_slider_start': 0,
		'price_slider_stop': 0,
		'load_auto_facet': 0,
		'listing_mode': "",
		'grouping': 0,
	},
	'banner': {
		'view': function(banner) {
			$.ajax({
				type: "GET",
				url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/900v',
				data: {
					'id' : banner
				},
			});
		},
		'click': function(banner) {
			$.ajax({
				type: "GET",
				url: cyclone3.domain + '/' + cyclone3.lng + '/service/click',
				data: {
					'id' : banner
				},
			});
		},
		'process': {
		},
		'activity': {
		}
	},
	'search': {
		'searchInstance': null,
		'searchDefaultString': '',
		'initAutoSuggest': function(elementId, parentId) {
			return new C3Search.autoSuggest(elementId, {
					delay: 400,
					script:	function (input) {
						if ($('#selectedCategory').data('searchgroup'))
						{
							return "/json/" + cyclone3.lng +  "/search/lite?g=" + $('#selectedCategory').data('searchgroup') + "&q=" + input;
						}
						else
						{
							return "/json/" + cyclone3.lng +  "/search/lite?q=" + input;
						}
					},
					noresults: "Nenašli sa žiadne zodpovedajúce výsledky",
					labelShowall: "Všetky výsledky",
					varname:	"input",
					width: '400',
					anchorPoint: 'bottomLeft',
					id: `head-search-${elementId}`,
					json: 1,
					loader: true,
					cleaner: true
				}, parentId
			);
		},
		'init': function() {
			this.searchInstance = this.initAutoSuggest('quicksearch');
			this.searchInstance = this.initAutoSuggest('filter-quicksearch', 'filter-search-wrapper');
		},
		'switchGroup': function(elem, evt) {
			cyclone3.cancelEvent(evt);
			var searchGroup = $(elem).data('searchgroup');
			$('#selectedCategory').text($(elem).text()).data('searchgroup', searchGroup);
			this.searchInstance.getSuggestions($('#filter-quicksearch').val(), true);
			this.searchInstance.getSuggestions($('#quicksearch').val(), true);
		}
	},
	'cart': {
		'updateCount': function () {						
			$(".header-cart-mini .load-placeholder").empty().addClass('loading').append('<i class="fa fa-cog fa-spin fa-2x fa-fw"></i>');
			
			var cart_mini_url = cyclone3.domain + '/service/cart_mini_chunk .load-placeholder';
			$(".header-cart-mini .input-group-addon").load(cart_mini_url + '.load-placeholder', function(responseTxt, statusTxt){
				if(statusTxt == "success"){
					$(".cart-mini-mobile-amount").text($(".header-cart-mini .load-placeholder").data("cart-amount"));
				}
			});
				
		},
		'remove': function(elem, ID, amount) {			
			$.ajax(
			{
				type: 'GET',
				url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart/action?action=del&ID=' + ID,
				dataType: 'json',
				success: function(data) {
					try{
						c3site.cart.updateCount();						
						if ($(elem).data("reload") == 1) {
							//nechem notifikaciu ale refresh
							location.reload();
						} 
					}catch(e) {
						cyclone3.log('error ' + e);
					}
				}
			});

			g_removeFromCart("[data-ec-id='" + ID + "']", amount);
		},
		'add': function(elem, ID, amount, fitment, ref_ID) {
			
			if(!amount) {
				if ($(elem).data('default-count')>0) {
                    amount = $(elem).data('default-count');
                } else {
					amount = 1;
				}
			}
            var product;
			if ($(".product-list-item[data-id='" + ID + "']").length) {
				product = $(".product-list-item[data-id='" + ID + "']");            
			}
			if ($(".product-detail[data-id='" + ID + "']").length) {
				product = $(".product-detail[data-id='" + ID + "']");
            }
			var add_ref_id = "";
			if(typeof(ref_ID) === "undefined" || ref_ID > 0) {
				add_ref_id = '&ref_id=' + ref_ID;
			}
			$.ajax(
			{
				type: 'GET',
				url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart/action?action=add&ID=' + ID + '&amount=' + amount + '&fitment=' + fitment + add_ref_id,
				dataType: 'json',
				success: function(data) {
					try{
						c3site.cart.updateCount();
						if ($(elem).data("reload") == 1) {
							//nechem notifikaciu ale refresh
							location.reload();
						} else {						
							/* send popup notify */
							c3site.popupNotify.title = c3site.l10n.cartAdded;
							c3site.popupNotify.message = "<strong>" + amount + "x</strong> " + product.data("product-name") + " " + c3site.l10n.inCart;
							c3site.popupNotify.message_extended = "";
							if (product.find(".tyre_fitment").length)
							{
								c3site.popupNotify.message_extended=product.find(".tyre_fitment").html();
							}
							c3site.popupNotify.url = cyclone3.domain + "/" + cyclone3.lng + "/service/cart";
							c3site.popupNotify.type = "success";						
							if(c3site.popupNotify.time > 0) {
								clearInterval(c3site.popupNotify.timer);
								c3site.popupNotify.time = 0;
								
							}
							c3site.popupNotify.timer = setInterval(c3site.popupNotify.push,1);
						}
					}catch(e) {
						cyclone3.log('error ' + e);
					}
				}
			});
			g_addToCart("[data-ec-id='" + ID + "']", amount); 
		},
		'add_variant': function(elem, ID, amount, variant, ref_ID) {
			if(!amount) {
				if ($(elem).data('default-count')>0) {
                    amount = $(elem).data('default-count');
                } else {
					amount = 1;
				}
			}
			
			if(typeof(variant) === "undefined" || variant == 0) {
				$('#product_variant').parents(".form-group").addClass("has-error");
				return;
			} else {
				$('#product_variant').parents(".form-group").removeClass("has-error");
			}
            var product;
			if ($(".product-list-item[data-id='" + ID + "']").length) {
				product = $(".product-list-item[data-id='" + ID + "']");            
			}
			if ($(".product-detail[data-id='" + ID + "']").length) {
				product = $(".product-detail[data-id='" + ID + "']");
            }
			var add_ref_id = "";
			if(typeof(ref_ID) === "undefined" || ref_ID > 0) {
				add_ref_id = '&ref_id=' + ref_ID;
			}
			$.ajax(
			{
				type: 'GET',				
				url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart/action?action=add&ID=' + ID + '&amount=' + amount + '&variant=' + variant + add_ref_id,
				dataType: 'json',
				success: function(data) {
					try{
						c3site.cart.updateCount();
						if ($(elem).data("reload") == 1) {
							//nechem notifikaciu ale refresh
							location.reload();
						} else {						
							/* send popup notify */
							c3site.popupNotify.title = c3site.l10n.cartAdded;
							c3site.popupNotify.message = "<strong>" + amount + "x</strong> " + product.data("product-name") + ", " + variant + " " + c3site.l10n.inCart;
							c3site.popupNotify.message_extended = "";
							if (product.find(".tyre_fitment").length)
							{
								c3site.popupNotify.message_extended=product.find(".tyre_fitment").html();
							}
							c3site.popupNotify.url = cyclone3.domain + "/" + cyclone3.lng + "/service/cart";
							c3site.popupNotify.type = "success";						
							if(c3site.popupNotify.time > 0) {
								clearInterval(c3site.popupNotify.timer);
								c3site.popupNotify.time = 0;
								
							}
							c3site.popupNotify.timer = setInterval(c3site.popupNotify.push,1);
						}
					}catch(e) {
						cyclone3.log('error ' + e);
					}
				}
			});
			g_addToCart("[data-ec-id='" + ID + "']", amount, variant); 
		}
	},
	'product': {
		'scrollTo': function () {
			var product = $(".product-modifications").find(".active");
			if (product.length) {				
				$('html, body').animate({
					scrollTop: product.offset().top - 50 
				}, 500)
            }
		},
		'compare': {
			'getCount': function (forceReload) {
				cyclone3.log('[product.compare.getCount]');
				
				var uri = cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/compare/action';
				$.ajax(
				{
					type: "GET",
					url: uri,
					dataType: 'json',
					success: function(data){
						try
						{
							c3site.product.compare.updateCount(data);
						}catch(e){
							cyclone3.log('error ' + e);
						}
					}
				});
			},
			'updateCount': function (data) {
				cyclone3.log('[product.compare.updateCount]');
				var count = $(data).find('compare count').text();
				if(!count){
					count='0';
				}
				if (count > 0) {
					$('#compare_container').show(); 
                } else {
					$('#compare_container').hide();
				}
				//$('#compare_container .info').html($(data).find('compare info').text()).parent().removeClass('empty');
				$(".compare_count").text("(" + data.count + ")");
			},
			'remove': function(elem, ID, callback){
				if (!callback)
				{ callback = function(){ cyclone3.log('no delete callback defined'); }; }
				//ga('send', 'event', 'Comparator', 'Remove', ID.toString());
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/compare/action?action=rem&ID=' + ID,
					dataType: 'json',
					success: function(data){
						try{
							c3site.product.compare.updateCount(data);
							var productCompare = $(".compare__product").find("[data-id='" + ID + "']");

							productCompare.fadeOut();
							setTimeout(function() {
								productCompare.remove();
								
								// change content if there are no products to compare
								if($(".compare__product").find('li').length == 0) {
									$('.compare__wrapper').remove();
									$('.form__header').after('\
										<div class="alert alert-warning mb-0">\
											<h2 class="h2 mb-3 mt-3 bold text-center">' + c3site.l10n.compareEmpty + '</h2>\
											<p class="pb-2 text-center">' + c3site.l10n.compareAddProducts + '</p>\
										</div>\
									');
								}
							}, 1000);

						}catch(e){
							cyclone3.log('error ' + e);
						}
					}
				});
			},
			'add': function(elem, ID, action, replace){
				//ga('send', 'event', 'Comparator', 'Add', ID.toString());
				
				if (replace)
				{
					$.ajax(
					{
						type: "GET",
						url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/compare/action?action=del&ID=' + replace,
						dataType: 'json',
						success: function(data){
							try{
								c3site.product.compare.add(elem, ID, action);
							}catch(e){
								cyclone3.log('error ' + e);
							}
						}
					});
				}
				else
				{

					$.ajax(
					{
						type: "GET",
						url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/compare/action?action=add&ID=' + ID,
						dataType: 'json',
						success: function(data){
							try{
								c3site.product.compare.updateCount(data);
								if(elem)
								{
									/* send popup notify */
									c3site.popupNotify.title = c3site.l10n.compareAdded;
									c3site.popupNotify.message_extended = "";
									c3site.popupNotify.message = "Počet produktov v porovnávači: <strong>" + data.count + "</strong><br>Pre zobrazenie porovnávača kliknite sem.";
									c3site.popupNotify.url = cyclone3.domain + "/" + cyclone3.lng + "/service/product_compare";
									c3site.popupNotify.type = "alert";						
									if(c3site.popupNotify.time > 0) {
										clearInterval(c3site.popupNotify.timer);
										c3site.popupNotify.time = 0;
									}
									c3site.popupNotify.timer = setInterval(c3site.popupNotify.push,1);
								}
								
								
							}catch(e){
								cyclone3.log('error ' + e);
							}
						}
					});
				}
			}
		},
		'filter': {
			'text': [],
			'primary_params': {},
			'temp': {},
			'urlExtended': null,		
			'pathUrl': null,
			'clickElem': '',		
			'clickElemStatus': false,		
			'changeUrl': function(page, url) {
				url += document.location.hash;
				if (typeof (history.pushState) != "undefined") {
					var obj = { Page: page, Url: url };
					history.pushState(obj, obj.Page, obj.Url);
				} else {
				}
			},
			'initialize': function ()
			{
				if ($('#facet').data("mode") == "roofset")
				{
					c3site.product.filter.initialize_roofset();
				}
				if ($('#facet').data("mode") == "wheel_al" || $('#facet').data("mode") == "wheel_st")
				{
					c3site.product.filter.initialize_car();
				}				
				
				$.ajax
				(
					{
						type: "GET",
						url: c3site.product.filter.urlExtended,
						dataType: "json",
						success: function(json)
						{
							var facet = $('#facet');
							facet.find('.hits').text(json.hits1);
							
							if (json.hits2 == 0) {
								return;
							}

							// remove aside filter loading spinner
							$('.filter__loading').remove();
							// show aside filter items on ready
							$('.filter_rozsireny fieldset').ready(function() {
								$('.filter_rozsireny fieldset, .filter_rozsireny .btn-group').css({'height': 'auto', 'opacity': '1'});
							})
							
							if (c3site.pageData.load_auto_facet) {
								//generujem auto facet
								for (var field in json.fields)
								{
									var tmpField = field.replace(/^.*?\./,'').replace(/^p_/,'');
									if (tmpField == "price" || tmpField == "main" || tmpField == "video") {
										continue;
									}
									label_url = "";
									if (is_primary) {
											label_url = json.fields[field].label_url;
									}
									var default_template = '<fieldset  data-param="' + tmpField + '" data-filtertype="scrollable_checkbox" id="p_' + tmpField + '" json.fields[field].items[fieldItem].label_url="'+is_primary+'" data-label-url="' + label_url +'">'
										+ '<div class="btn-group" data-toggle="buttons">'
											+'<p>' + json.fields[field].label + '</p>'
										+ '</div>'
									+'</fieldset>';
									
									$(default_template).insertAfter('.filter_rozsireny h4');
								}
							}
									
							for (var field in json.fields)
							{
								var tmpField = field.replace(/^.*?\./,'').replace(/^p_/,'');
								var tmpFieldWrapper = $('[data-param="' + tmpField + '"]');
								var tmpFilterType = $(tmpFieldWrapper).data('filtertype');
								var is_primary = json.fields[field].is_primary;
								
								if(tmpFilterType == 'select' || tmpFilterType == 'multiselect')
								{
									$('#p_' + tmpField).empty();
									if(tmpFilterType == 'select')
									{
										$('#p_' + tmpField).append('<option value=""></option>');
									}
									
									for (var fieldItem in json.fields[field].items)
									{
										$('#p_' + tmpField).append('<option  data-is-primary="'+ is_primary +'" value="' + json.fields[field].items[fieldItem].label + '" data-label-url="' + json.fields[field].items[fieldItem].label_url +'">' + json.fields[field].items[fieldItem].label + '</option>');
									}
								}
								else if (tmpFilterType == 'dropdown_checkbox')
								{
									tmpFieldWrapper.find('ul').remove();
									var dd_template = '<ul class="dropdown-menu"><table class="check-one-row"><tbody>';
									for (var fieldItem in json.fields[field].items)
									{
										if (fieldItem != "") {											
											carLogo = "";
											if (tmpFieldWrapper.find('div').hasClass('car-brand')) {
												//carLogo = json.fields[field].items[fieldItem].label_url +'-logo car-logo';	
											};
											dd_template += '<tr><td>';
											dd_template += '<input type="checkbox" class="table-checkbox" name="p_' + tmpField + '" value="' + json.fields[field].items[fieldItem].label + '" data-is-primary="'+ is_primary +'" data-label-url="' + json.fields[field].items[fieldItem].label_url +'"/>';
											dd_template += '<label></label><span class="' + carLogo + '">' + json.fields[field].items[fieldItem].label + '</span>';
											dd_template += '</td></tr>';
										}
									}
									dd_template += '</tbody></table></ul>';
									tmpFieldWrapper.find('div').append(dd_template);
									
									/* dvojrozmer - naplnenie hodnot pre selecty z povodnych width ... */
									if (tmpField == 'width' || tmpField == 'height' || tmpField == 'radius'){
										tmpFieldWrapper = $('[data-param="' + tmpField + '_dr"]');
										dd_template = $(dd_template);
										dd_template.find('[type="checkbox"]').each(function(){
											$(this).attr('name',this.name+'_dr');
											$(this).attr('data-is-primary','0');
										});
										tmpFieldWrapper.find('div').append(dd_template);
									};
										
								}
								else if (tmpFilterType == 'scrollable_checkbox')
								{
									tmpFieldWrapper.find('table').remove();
									var additional_class = "";	
									if (tmpField == "main") {
										additional_class = " height_auto";	
									}
									if (tmpFieldWrapper.hasClass("not-multiselect")) {										
										additional_class += " check-one-row";
                                    }
									var dd_template = '<table><tbody class="' + additional_class + '">';
									for (var fieldItem in json.fields[field].items)
									{
										if (fieldItem != "") {
											value = json.fields[field].items[fieldItem].label;			
											if (tmpField == "main") {
												value = fieldItem;
											}
											dd_template += '<tr><td>';
											dd_template += '<input type="checkbox" class="table-checkbox" name="p_'+ tmpField
												+ '" value="' + value
												+ '" data-is-primary="'+ is_primary
												+ '" data-label-url="' + json.fields[field].items[fieldItem].label_url +'"/>';
											dd_template += '<label></label><span>' + json.fields[field].items[fieldItem].label + '</span>';
											dd_template += '</td></tr>';
										}
									}
									dd_template += '</tbody></table>';
									tmpFieldWrapper.find('div').append(dd_template);										
								}
								else if (tmpFilterType == 'checkbox')
								{	
									for (var fieldItem in json.fields[field].items)
									{
										count = parseInt(json.fields[field].items[fieldItem].count)
										if (fieldItem != "" && count > 0) {
											tmpFieldWrapper.find('input[name=\'p_'+ tmpField + '\']').removeAttr("disabled");											
										}
									}
								}
								else if (tmpFilterType == 'price_slider')
								{
									var priceRange={};
									priceRange['min'] = Math.floor(json.fields[field].min);
									priceRange['max'] = Math.floor(json.fields[field].max);
									sliderId= 'slider_'+field;
									var ps_template = '<div><input type="text" id="amount" class="price-value" readonly><div id="'+sliderId+'"></div></div>';
									tmpFieldWrapper.find('div.header').append(ps_template);
									
									if (!c3site.pageData.price_slider_start) {
										c3site.pageData.price_slider_start = priceRange['min'];
									}
									if (!c3site.pageData.price_slider_stop) {
										c3site.pageData.price_slider_stop = priceRange['max'];
									}
									$( function() {
										$( '#'+sliderId ).slider({
											range: true,
											min: priceRange['min'] ,
											max: priceRange['max'] ,
											values: [ c3site.pageData.price_slider_start , c3site.pageData.price_slider_stop  ],
											slide: function( event, ui ) {
												$( "#amount" ).val(
													moneyFormat.to(ui.values[ 0 ])
													+ " - "
													+ moneyFormat.to(ui.values[ 1 ])
												);
											},
											stop: function( event, ui ) {
												c3site.product.filter.update();
											}
										});
										$( "#amount" ).val(
											moneyFormat.to($( '#'+sliderId ).slider( "values", 0 ))
											+ " - "
											+ moneyFormat.to($( '#'+sliderId ).slider( "values", 1 ))
										);
									});
								}
								else if (tmpFilterType == 'round_list')
								{
									tmpFieldWrapper.find('ul').remove();
									var dd_template = '<ul class="after_product_rozmery filter_tab_list" role="tablist">';
									for (var fieldItem in json.fields[field].items)
									{
										if (fieldItem != "") {
											var value = json.fields[field].items[fieldItem].label;
											dd_template += '<li role="presentation"><a data-value="' + value + '" data-name="p_'+ tmpField + '"  href="#' + value + '" aria-controls="' + value + '" role="tab" data-toggle="tab">' + value + '"</a></li>';
										}
									}
									dd_template += '</ul>';
									dd_template += '<input type="hidden" name="p_'+ tmpField
												+ '" data-is-primary="'+ is_primary
												+ '" data-label-url="' + json.fields[field].items[fieldItem].label_url +'"/>';
									tmpFieldWrapper.find('div').append(dd_template);
								}		
							}
							
							if (Object.keys(c3site.product.filter.primary_params).length > 0) {
								$.each(c3site.product.filter.primary_params, function( name, value ) {
									var chbox = facet.find('input[name="p_' + name + '"][value="' + value + '"]');
									chbox.attr('checked', true);
									chbox.parents('.btn-group').find('button .selected').text(value);
								});
								var hash = "";
								if (document.location.hash)
								{
									hash = document.location.hash.replace(/^#/, '');
								}								
								c3site.product.filter.update(hash);	
							}						
							else if (document.location.hash)
							{
								var hash = document.location.hash.replace(/^#/, '');
								c3site.product.filter.update(hash);						
							}							
						}
					}
				);
			},
			'update': function (hash)
			{
				var is_roofset = false;
				if ($('#facet').data("mode") == "roofset")
				{
					is_roofset = true;
					c3site.product.filter.update_roofset();
				}
				var is_wheel = false;
				if ($('#facet').data("mode") == "wheel_al" || $('#facet').data("mode") == "wheel_st")
				{
					is_wheel = true;
					c3site.product.filter.update_car();
				}
				var is_tyre = false;
				if ($('#facet').data("mode") == "tyre")
				{
					is_tyre = true;
				}
				var hashparams = [
					c3site.product.filter.getParams(),
					c3site.product.filter.getParams("primary"),
					c3site.product.filter.getParams("secondary")
				];
				
				if (hash) {
                    hashparams[0] = hashparams[0] + "&" + hash;
					hashparams[2] = hash;
                }
				
				document.location.hash = hashparams[2].replace(/^&/, '');
				var facet = $('#facet');
			
				$.when(					
					$.ajax({
						type: "GET",
						url: c3site.product.filter.urlExtended + "&" + hashparams[0],
						dataType: "json",
						success: function(json)
						{
							var enabledItems={};
							var checkedItems={};
							
							for (var field in json.fields)
							{	
								for (var fieldItem in json.fields[field].items)
								{
									var tmpField = field.replace(/^.*?\./,'').replace(/^p_/,'');
									enabledItems[tmpField + '_' + json.fields[field].items[fieldItem].label]=json.fields[field].items[fieldItem].count;
									if ( json.fields[field].items[fieldItem].checked == 'true')
									{
										checkedItems[tmpField + '_' + json.fields[field].items[fieldItem].label]=json.fields[field].items[fieldItem].checked;
									}									
								}
							}
													
							facet.find('fieldset').each(function()
							{								
								var tmpField = $(this).data('param');
								var tmpFieldWrapper = $('[data-param="' + tmpField + '"]');
								var tmpFilterType = $(tmpFieldWrapper).data('filtertype');
								
								if (is_roofset && (tmpField == "car" || tmpField == "model" || tmpField == "year")) {
									return;
								}
								if (is_wheel && (tmpField == "car_brand" || tmpField == "car_model" || tmpField == "car_year" || tmpField == "car_type")) {
									return;
								}
								
								if (tmpFilterType == 'dropdown_checkbox')
								{
									var i=0;
									tmpFieldWrapper.find('input[type=\'checkbox\']').each( function()
									{
										/* dvojrozmer - neschovavam moznosti */
										if (tmpField.indexOf('_dr') > -1){
											
										} else {

											if (c3site.product.filter.clickElem != 'p_' +tmpField || c3site.product.filter.clickElemStatus == false) {
												if(enabledItems[tmpField + '_' + $(this).attr('value')])
												{							
													i++;		
													$(this).parent().show();			
													$(this).removeAttr("disabled");								
												}
												else
												{											
													if (tmpField != "car")
													{
														$(this).parent().hide();		
														$(this).attr("disabled", true);
													}																		
												}										
											}
											
											if(checkedItems[tmpField + '_' + $(this).attr('value')])
											{
												$(this).attr('checked', true);
												$(this).parents('.btn-group').find('button .selected').text($(this).attr('value'));
											}
										}
									});
								}
								else if (tmpFilterType == 'scrollable_checkbox')
								{
									//tmpFieldWrapper.hide();
									tmpFieldWrapper.find('input[type=\'checkbox\']').each( function()
									{
										if (c3site.product.filter.clickElem != 'p_' +tmpField) {
											if(enabledItems[tmpField + '_' + $(this).attr('value')])
											{
												$(this).parent().show();
												$(this).removeAttr("disabled");
												//tmpFieldWrapper.show();
											}
											else
											{
												if (tmpField != 'main') {
													$(this).parent().hide();
													$(this).attr("disabled", true);											
												}
											}
										}
										
										if(checkedItems[tmpField + '_' + $(this).attr('value')])
										{
											$(this).attr('checked', true);
											$(this).parents('.btn-group').find('button .selected').text($(this).attr('value'));
										}
									});										
								}
								else if (tmpFilterType == 'round_list')
								{
									var selected_round_list = "";
									tmpFieldWrapper.find('a').each( function()
									{
										if (c3site.product.filter.clickElem != 'p_' +tmpField) {
											if(enabledItems[tmpField + '_' + $(this).data('value')])
											{
												$(this).parent().show();
												$(this).removeAttr("disabled");
											}
											else
											{
												$(this).parent().hide();
												$(this).attr("disabled", true);
											}
										}
										
										if(checkedItems[tmpField + '_' + $(this).data('value')])
										{
											$(this).attr('aria-expanded', 'true');
											$(this).parent().addClass('active');
											selected_round_list = $(this).data('value');
										}
									});
									tmpFieldWrapper.find('input').val(selected_round_list);
								}
								else if (tmpFilterType == 'price_slider')
								{
									/*
									var priceSlider = document.getElementById("slider_p_"+tmpField);
									if (json.fields["p_"+tmpField])
									{
										var priceRange={};
										priceRange['min'] = Math.floor(json.fields["p_"+tmpField].min);
										priceRange['max'] = Math.floor(json.fields["p_"+tmpField].max);
										
										sliderId= 'slider_p_'+tmpField;
										
										$( '#'+sliderId ).slider( "option", "min", priceRange['min'] );
										$( '#'+sliderId ).slider( "option", "max", priceRange['max'] );
										$( '#'+sliderId ).slider( "values", 0, priceRange['min']);
										$( '#'+sliderId ).slider( "values", 1, priceRange['max']);
										
										$( "#amount" ).val(
											moneyFormat.to(priceRange['min'])
											+ " - "
											+ moneyFormat.to(priceRange['max'])
										);
										
									}
									*/
								}		
								else if (tmpFilterType == 'checkbox')
								{
									// todo...
								} 	 
							});
							//$('#facet').find('.hits').text(json.hits2);					
						}
					})		
				).then(function() {
					var hashparams = [
						c3site.product.filter.getParams(),
						c3site.product.filter.getParams("primary"),
						c3site.product.filter.getParams("secondary")
					];
					c3site.product.list.load(hashparams);
				});			
				
			},			
			'initialize_roofset': function ()
			{
				$.ajax
				(
					{
						type: "GET",
						url: c3site.product.filter.urlExtended2,
						dataType: "json",
						success: function(json)
						{
							var facet = $('#facet');
							var tmpFieldWrapper = $('[data-param="car"]');
							var is_primary = 1;
							if (json.cars) {
								tmpFieldWrapper.find('ul').remove();
								var dd_template = '<ul class="dropdown-menu"><table class="check-one-row"><tbody>';
								for (var fieldItem in json.cars)
								{
									if (fieldItem != "") {											
										carLogo = "";
										if (tmpFieldWrapper.find('div').hasClass('car-brand')) {
											//carLogo = fieldItem +'-logo car-logo';	
										};
										dd_template += '<tr><td>';
										dd_template += '<input type="checkbox" class="table-checkbox" name="checkbox_car" value="' + json.cars[fieldItem].name + '" data-is-primary="'+ is_primary +'" data-label-url="' + fieldItem +'"/>';
										dd_template += '<label></label><span class="' + carLogo + '">' + json.cars[fieldItem].name + '</span>';
										dd_template += '</td></tr>';
									}
								}
								dd_template += '</tbody></table></ul>';
								tmpFieldWrapper.find('div').append(dd_template);
								tmpFieldWrapper.attr("disabled", false);
							} else {
								tmpFieldWrapper.attr("disabled", true);
							}
							$('[data-param="model"]').attr("disabled", true);							
							$('[data-param="year"]').attr("disabled", true);
						}
					}
				);
			},
			'update_roofset': function (hash)
			{
				var car = $('fieldset[data-param="car"]');
				var car_selected = car.find('input[type="checkbox"]:checked').data("label-url");
				var model = $('fieldset[data-param="model"]');
				var model_selected = model.find('input[type="checkbox"]:checked').data("label-url");
				var year = $('fieldset[data-param="year"]');
				var year_selected = year.find('input[type="checkbox"]:checked').data("label-url");
				
				if (Object.keys(c3site.product.filter.primary_params).length > 0) {
					car_selected = c3site.product.filter.primary_params.car;
					model_selected = c3site.product.filter.primary_params.model;
					year_selected = c3site.product.filter.primary_params.year;
				}
				
				var url = c3site.product.filter.urlExtended2
				if(typeof(car_selected) === "undefined") {
					return 1;
				} else {
					url += "&car=" + car_selected;
				}
				if(typeof(model_selected) !== "undefined") {
					url += "&model=" + model_selected;	
				}
				
				$.ajax({
					type: "GET",
					url: url,
					dataType: "json",
					success: function(json)
					{
						var facet = $('#facet');
						var tmpFieldWrapper = $('[data-param="model"]');
						tmpFieldWrapper.find('ul').remove();
						if (json.cars[car_selected].model) {	
							var is_primary = 1;
							var dd_template = '<ul class="dropdown-menu"><table class="check-one-row"><tbody>';						
							for (var fieldItem in json.cars[car_selected].model)
							{
								var checked = '';
								if (model_selected == fieldItem) {
                                    checked = 'checked';
                                }
								if (fieldItem != "") {											
									dd_template += '<tr><td>';
									dd_template += '<input type="checkbox" class="table-checkbox" name="checkbox_model" value="' + json.cars[car_selected].model[fieldItem].name + '" data-is-primary="'+ is_primary +'" data-label-url="' + fieldItem +'" '+checked+ '/>';
									dd_template += '<label></label><span>' + json.cars[car_selected].model[fieldItem].name + '</span>';
									dd_template += '</td></tr>';
								}
							}
							dd_template += '</tbody></table></ul>';
							tmpFieldWrapper.find('div').append(dd_template);
							tmpFieldWrapper.attr("disabled", false);
							if(typeof(model_selected) !== "undefined") {
								$('[data-param="year"]').attr("disabled", false);							
                            }
						} else {
							tmpFieldWrapper.attr("disabled", true);							
							$('[data-param="year"]').attr("disabled", true);		
						}
						if (Object.keys(c3site.product.filter.primary_params).length > 0) {
							$.each(c3site.product.filter.primary_params, function( name, value ) {
								var chbox = facet.find('input[name="checkbox_' + name + '"][data-label-url="' + value + '"]');
								if (chbox.length) {
									chbox.attr('checked', true);
									chbox.parents('.btn-group').find('button .selected').text(chbox.attr('value'));
								}
								delete c3site.product.filter.primary_params[name];
							});
						}
                    }
				});
			},
			'initialize_car': function ()
			{
				$.ajax
				(
					{
						type: "GET",
						url: c3site.product.filter.urlExtended2,
						dataType: "json",
						success: function(json)
						{
							var facet = $('#facet');
							var tmpFieldWrapper = $('[data-param="car_brand"]');
							var is_primary = 1;
							if (json.car_brand) {
								tmpFieldWrapper.find('ul').remove();
								var dd_template = '<ul class="dropdown-menu"><table class="check-one-row"><tbody>';
								for (var fieldItem in json.car_brand)
								{
									if (fieldItem != "") {											
										carLogo = "";
										if (tmpFieldWrapper.find('div').hasClass('car-brand')) {
											//carLogo = fieldItem +'-logo car-logo';	
										};
										dd_template += '<tr><td>';
										dd_template += '<input type="checkbox" class="table-checkbox" name="checkbox_car_brand" value="' + json.car_brand[fieldItem].name + '" data-is-primary="'+ is_primary +'" data-label-url="' + fieldItem +'"/>';
										dd_template += '<label></label><span class="' + carLogo + '">' + json.car_brand[fieldItem].name + '</span>';
										dd_template += '</td></tr>';
									}
								}
								dd_template += '</tbody></table></ul>';
								tmpFieldWrapper.find('div').append(dd_template);
								tmpFieldWrapper.attr("disabled", false);
							} else {
								tmpFieldWrapper.attr("disabled", true);
							}
							$('[data-param="car_model"]').attr("disabled", true);							
							$('[data-param="car_year"]').attr("disabled", true);
							$('[data-param="car_type"]').attr("disabled", true);							
						}
					}
				);
			},
			'update_car': function (hash)
			{
				var car = {
					car_brand : "",
					car_model: "",
					car_year : "",
					car_type : "",
				};
				
				// first setup car from dropdown
				$.each( car, function( key, value )
				{
					if ($('input[name="checkbox_'+ key +'"]').is(':checked'))
					{
						car[key] = $('input[name="checkbox_'+ key +'"]:checked').data("label-url");
					}
					if (typeof c3site.product.filter.temp[key] == "undefined") {
						c3site.product.filter.temp[key] = "";
					}
				});
				
				
				// if have setup from url / session, override setting with those
				if (Object.keys(c3site.product.filter.primary_params).length > 0)
				{
					$.each( car, function( key, value )
					{
						if (c3site.product.filter.primary_params[key])
						{
							car[key] =  c3site.product.filter.primary_params[key];
							delete c3site.product.filter.primary_params[key];
							c3site.product.filter.temp[key] = car[key];
						}
					});
				}
				
				// if parent changed, child are reseted to default
				var reset_rest = false;
				$.each( car, function( key, value )
				{	
					if (reset_rest)
					{
						car[key] = "";						
						var tmpFieldWrapper = $('[data-param="' + key + '"]'); 
						tmpFieldWrapper.removeClass("selectionWaiting");
						tmpFieldWrapper.find('button .selected').text(c3site.product.filter.text["default"]);
						tmpFieldWrapper.attr("disabled", true);
                    }
					else
					{
						if (c3site.product.filter.temp[key] != car[key]) {
							c3site.product.filter.temp[key] = car[key];
							reset_rest = true;
						}
					}
				});
							
				var url = c3site.product.filter.urlExtended2
				if(car.brand_selected == "")
				{
					return 1;
				}
				else
				{
					$.each( car, function( key, value )
					{
						if (value != "") {
							url += "&"+key+"=" + value;							
						}						
					});
				}				
				$.ajax({
					type: "GET",
					url: url,
					dataType: "json",
					async: false,
					success: function(json)
					{
						var facet = $('#facet');
						var data = json;
						var prev = "";
						$.each( car, function( key, value)
						{	
							if (prev != "")
							{
								data = data[prev];
                            }
							
							if (typeof data != "undefined" )
							{	
								data = data[key];
								var tmpFieldWrapper = $('[data-param="' + key + '"]');
								tmpFieldWrapper.find('ul').remove();
								
								if(typeof(data) === "undefined")
								{
									tmpFieldWrapper.attr("disabled", true);	
								}
								else
								{
									if (value == "")
									{
										tmpFieldWrapper.addClass("selectionWaiting");
									}
									else
									{
										tmpFieldWrapper.removeClass("selectionWaiting");
									}
								
									var dd_template = '<ul class="dropdown-menu"><table class="check-one-row"><tbody>';
									var match = false;
									for (var fieldItem in data)
									{
										var checked = '';
										if (value == fieldItem)
										{
											checked = 'checked="checked"';
											match = true;
											tmpFieldWrapper.find('button .selected').text( data[fieldItem].name );
										}																		
										dd_template += '<tr><td>';
										dd_template += '<input type="checkbox" class="table-checkbox" name="checkbox_'+ key +'" value="' + data[fieldItem].name + '" data-is-primary="1" data-label-url="' + fieldItem +'" '+checked+ '/>';
										dd_template += '<label></label><span>' + data[fieldItem].name + '</span>';
										dd_template += '</td></tr>';									
									}
									dd_template += '</tbody></table></ul>';
									tmpFieldWrapper.find('div').append(dd_template);
									tmpFieldWrapper.attr("disabled", false);
									if (match == false)
									{
										tmpFieldWrapper.find('button .selected').text(c3site.product.filter.text["default"]);
									}
								}
							}
							else
							{
								$('[data-param="'+ key +'"]').attr("disabled", true);
							}
							prev = value;
						});
                    }
				});
			},		
			'getParams': function (type) {
			
				//type=primary : primarne, do url (pre listing, pekna url)
				//type=secondary : ako premenne (dodatocne filtre pre listing)
				//type=undef : vsetky ako premenne (vsetko pre chunk)
				
				var parameterPrimary=[];		
				var parametersSecondary= "";				
				var parametersAll="";
				var param_size = {};
					param_size['width'] = 0;
					param_size['height'] = 0;
					param_size['radius'] = 0;

				const primaryParamsOfSizesFromHomepageFilter = [];

				$(".popup-box").each(function()
				{
					var fieldsetname = $(this).data('params');
					var values='';
					var valuesAdd='';
					
					if(values)
					{
						values = values + encodeURIComponent(";");
					}
					if(valuesAdd)
					{
						valuesAdd = valuesAdd + encodeURIComponent(";");
					}
					
					if($(this).find('.filter-active').val())
					{
						var checked = $(this).find('.filter-active');
						if (checked.data("is-primary") == "1" && checked.data("label-url") != "") {
							valuesAdd = valuesAdd + encodeURIComponent(checked.val());
						} else {
							values = values + encodeURIComponent(checked.val());
						}					
					}
				});
				
				$("fieldset").each(function()
				{
					var fieldsetname = $(this).data('param');
					var values='';
					var valuesAdd='';

					if ($(this).data('filtertype') == 'dropdown_checkbox')
					{
						if(values)
						{
							values = values + encodeURIComponent(";");
						}
						if(valuesAdd)
						{
							valuesAdd = valuesAdd + encodeURIComponent(";");
						}
						
						if($(this).find('input[type="checkbox"]:checked').val())
						{
							var checked = $(this).find('input[type="checkbox"]:checked');
							const checkedName = checked.attr("name");
							const checkedDataLabelUrl = checked.data("label-url");

							if (checked.data("is-primary") == "1" && checkedDataLabelUrl != "") {
								function addPrimarySizeParamFromHomepageFilter() {
									primaryParamsOfSizesFromHomepageFilter
										.push(`${checkedName}=${checkedDataLabelUrl}`);
								}

								const isCheckedNameSize = 
									checkedName === "p_width" || checkedName === "p_height" || checkedName === "p_radius";

								if (isCheckedNameSize) {
									const key = checkedName.split("p_")[1];
									param_size[key] = checkedDataLabelUrl;
									addPrimarySizeParamFromHomepageFilter();
								} else {
									parameterPrimary.push(checkedDataLabelUrl);
								}
								valuesAdd = valuesAdd + encodeURIComponent(checked.val());
							} else {
								values = values + encodeURIComponent(checked.val());
							}			
						}
					}
					else if ($(this).data('filtertype') == 'scrollable_checkbox')
					{
						if(values)
						{
							values = values + encodeURIComponent(";");
						}
						
						$(this).find('input[type="checkbox"]:checked').each(function()
						{
							var value = $(this).val();
							var name_url = $(this).data("label-url");
							if ($(this).data("is-primary") == "1" &&  name_url != "" && name_url != "undefined")
							{
								parameterPrimary.push(name_url);
								valuesAdd = valuesAdd + encodeURIComponent(value);
							}
							else
							{
								values = values + encodeURIComponent(value+";");
							}
						});						
					}
					else if ($(this).data('filtertype') == 'checkbox')
					{
						if(values)
						{
							values = values + encodeURIComponent(";");
						}
						
						$(this).find('input[type="checkbox"]:checked').each(function()
						{
							values = values + encodeURIComponent($(this).val());
						});
					}					
					else if ($(this).data('filtertype') == 'price_slider')
					{
						
						var priceValues=[0,0];
						var priceSlider = $(this).find( '.ui-slider' );
						if (priceSlider.slider( "values", 0 ) > 0) {
							priceValues[0] = priceSlider.slider( "values", 0 );
							priceValues[1] = priceSlider.slider( "values", 1 );
							parametersSecondary =  parametersSecondary + "&priceRange="+priceValues;	
							parametersAll =  parametersAll + "&priceRange="+priceValues;	
							
                        }					
					}				
					else if ($(this).data('filtertype') == 'round_list')
					{
						
						if(values)
						{
							values = values + encodeURIComponent(";");
						}
						
						if($(this).find('input[type="hidden"]').val() != "")
						{
							values = values + encodeURIComponent($(this).find('input[type="hidden"]').val());			
						}	
					}
					
					if (values!=='')
					{
						parametersSecondary = parametersSecondary + "&";
						parametersSecondary = parametersSecondary + 'p_' + fieldsetname; 
						parametersSecondary = parametersSecondary + "=";
						parametersSecondary = parametersSecondary + values;
					}
					if (valuesAdd!=='')
					{
						parametersAll = parametersAll + "&";
						parametersAll = parametersAll + 'p_' + fieldsetname; 
						parametersAll = parametersAll + "=";
						parametersAll = parametersAll + valuesAdd;
					}
					
				});

				if (param_size.width && param_size.height && param_size.radius)
				{
					var temp = param_size.width+"-" + param_size.height +"-" + param_size.radius;						
					parameterPrimary.push(temp);
					primaryParamsOfSizesFromHomepageFilter.length = 0;
				}

				/**
				 * 
				 * create url path for filters
				 */
				 // set variables for filter
				if(c3site.product.filter.pathUrl == '/') {
					c3site.product.filter.pathUrl = '/pneumatiky'; // FIXME:
				}
				var parameterPrimaryUrl = cyclone3.domain + c3site.product.filter.pathUrl + "/f/", // create url for filters
				filterBtn = $('.facet-without-change-url .btn__filter'); // homepage filter button
				
				// if not empty selection from filter
				if (parameterPrimary.length > 0)
				{
					$.each(parameterPrimary, function( index, value ) {
						// get url slugs for filter url
						if (index < 1) {
							parameterPrimaryUrl += value;
						} else {
							parameterPrimaryUrl += "/" + value;
						}
					});
					parameterPrimaryUrl += "/";
					// aside filter
					if(!$('.facet-without-change-url').length)
					{
						// update filter url
						c3site.product.filter.changeUrl(parameterPrimaryUrl ,parameterPrimaryUrl);
					// homepage filter
					}
					else
					{
						filterBtn.removeAttr('disabled');
						// redirect to filter url after click
						filterBtn.on('click', function() {
							window.location.href = `${
								parameterPrimaryUrl
							}?mobile_filter_open=1#${
								primaryParamsOfSizesFromHomepageFilter.join("&")
							}`;
						});
					}
					
				// if empty selection from filter
				}
				else
				{
					// aside filter
					if(!$('.facet-without-change-url').length) {
						c3site.product.filter.changeUrl(null, cyclone3.domain + c3site.product.filter.pathUrl);
					// homepage filter
					} else {
						filterBtn.attr('disabled', true);
					}
				}
				if (type == "primary") {
					return parameterPrimary;
				} else if (type == "secondary") {	
					return parametersSecondary;
				} else {
					return parametersAll+parametersSecondary;
				}
				
			}
		},
		'list': {
			'setup_remaining': function (data) {				
				var product_list = $('#main');			
				var start = parseInt(data.attr('start'));
				var limit = parseInt(data.attr('page_limit'));
				var remaining = parseInt(data.attr('remaining'));
				var hits = parseInt(data.attr('count'));				
				
				product_list.attr('data-start', start).attr('data-remaining', remaining).attr('data-count', hits);
				product_list.parent().find('.pagination span.limit').text(limit);
				$('#facet').find('.hits').text(hits);
				
				if(remaining>0)
				{
					product_list.parent().find('.pagination').show();								
					product_list.parent().find('.pagination span.remaining').text(remaining);
					if (remaining < limit) {
						product_list.parent().find('.pagination span.limit').text(remaining);
					}
				}
				else
				{
					product_list.parent().find('.pagination').hide();
				}
				c3site.pageData.page_next_start = parseInt(start) + parseInt(limit);
			},
			'load': function (hashparams) {
				
				var param_start=0,
						match_,
						product_list = $('#main'),
						button = $('#btn-load-products'),
						icon = $('<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>'),
						notification = $('.notification');
						
						$('#facet').find(button).addClass('loading').append(icon);
						product_list.css({'opacity': '.5'});
						if(notification.hasClass('notification--sm')) {
							if($(window).width() <= 768) {
								notification.show();
							}	
						} else {
							notification.show();
						}
								
				if (hashparams[0])
				{
					hashparams[0]=hashparams[0].replace(/&&/,'&');
					hashparams[0]=hashparams[0].replace(/&$/,'');
				}
				var listing_mode = '';
				
				if (c3site.pageData.listing_mode != '') {
					listing_mode = '&listing_mode=' + c3site.pageData.listing_mode;					
				}
				
				$.ajax(
				{
					type: "GET",
					url: cyclone3.domain + '/' + cyclone3.lng
						+ '/chunk/' + (c3site.pageData.more_chunk || 'products') + '?node=' + c3site.pageData.nodeId
						+ '&grouping=' + c3site.pageData.grouping
						+ '&sort=' + c3site.pageData.sort
						+ '&start=' + param_start + '&page_limit=' + c3site.pageData.page_limit_more + listing_mode
						+ '&' + (hashparams[0]) + c3site.pageData.filter_extra,
					dataType: 'html',
					success: function(data) {
						try
						{
							product_list.empty();
							product_list.css({'opacity': '1'});
							product_list.append($(data).find('#main > *'));							
							c3site.product.list.setup_remaining($(data).find('#main'));
							$('#facet').find(button).removeClass('loading').find(icon).remove();
							notification.fadeOut('slow');
						}
						catch(e)
						{
							alert(e);
						}
					}
				});
				
			},	
			'loadMore': function()
			{
				if(typeof(c3site.pageData.page_next_start) === "undefined") {
					c3site.pageData.page_next_start = c3site.pageData.page_limit_default;
				}
							
				var product_list = $('#main'),
						button = $('.pagination').find('#btn-load-products'),
						icon = $('<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>');
				
				button.addClass('loading').append(icon);
				var url = cyclone3.domain + '/' + cyclone3.lng + '/chunk/' + (c3site.pageData.more_chunk || 'products');
				url += '?grouping=' + c3site.pageData.grouping;
				url += '&sort=' + c3site.pageData.sort;
				url += '&start=' + c3site.pageData.page_next_start;
				url += '&page_limit=' + c3site.pageData.page_limit_more;
				url += '&page_limit_more=' + c3site.pageData.page_limit_more;	
				url += '&listing_mode=' + c3site.pageData.listing_mode;			
				if (product_list.data("search") == true)
				{
					url += '&q=' +  $('#search_page_form input').val();
				}
				else
				{
					url += '&node=' + c3site.pageData.nodeId;
					url += '&' + c3site.product.filter.getParams() + c3site.pageData.filter_extra;
				}
				
				$.ajax(
				{
					type: "GET",
					url: url,
					dataType: 'html',
					success: function(data) {
						try
						{	
							var scrollTo;							
							product_list.find('.last').removeClass('last');
							button.removeClass('loading').find(icon).remove();
							
							$(data).find('#main > .product-list-item').each(function(index){
								if (index === 0) {
									scrollTo = $(this).data("id");
								}
								product_list.append(this);
							});							
							c3site.product.list.setup_remaining($(data).find('#main'));
						}
						catch(e)
						{
							alert(e);
						}
					}
				});
			}
		}
	},
	
	'popupNotify': {
		'time': 0,
		'timer': "",
		'push': function(){
			c3site.popupNotify.time++;
			if(c3site.popupNotify.time == 200) {
				clearInterval(c3site.popupNotify.timer);
				c3site.popupNotify.timer = 0;
				c3site.popupNotify.send();		
				clearInterval(c3site.popupNotify.timer);		
			}
		},
		'title': "",
		'message': "",
		'type': "",
		'url': "",
		'destroy': function(){
			c3site.popupNotify.title = "";
			c3site.popupNotify.message = "";
			c3site.popupNotify.message_extended = "";			
			c3site.popupNotify.type = "";
			c3site.popupNotify.url = "";
			c3site.popupNotify.timer = 0;
			clearInterval(c3site.popupNotify.timer);
		}, 
		'send': function(){
			if(c3site.popupNotify.title !== "") {
				var timer = 500;
				if(c3site.popupNotify.type=="cart") {
					timer = 2000;
				}
				$.notify({
					// options
					icon: '',
					title: c3site.popupNotify.title,
					message: c3site.popupNotify.message,
					url: c3site.popupNotify.url,
				},{
					// settings
					element: 'body',
					position: null,
					type: c3site.popupNotify.type,
					allow_dismiss: true,
					newest_on_top: true,
					showProgressbar: false,
					placement: {
						from: "top",
						align: "center"
					},
					offset: 30,
					spacing: 10,
					z_index: 1031,
					delay: 50,
					timer: timer,
					url_target: '_self',
					mouse_over: null,
					animate: {
						enter: 'animated fadeInDown',
						exit: 'animated fadeOutUp'
					},
					onShow: null,
					onShown: null,
					onClose: null,
					onClosed: null,
					icon_type: 'class',
					template: '\
						<div data-notify="container" class="popup-notify col-md-5 col-xs-10 alert alert-{0}" role="alert">\
							<button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="fa fa-times" aria-hidden="true"></i></button>\
							<span data-notify="icon"></span>\
							<span data-notify="title" class="bold">{1}</span>\
							<span data-notify="message" class="d-block pt-1 notify-message">{2}\
							<a href="{3}" target="{4}" data-notify="url"></a></span>\
							<span data-notify="message_extended" class="d-block pt-1 notify-message_extended">'+c3site.popupNotify.message_extended+'</span>\
							<div class="progress" data-notify="progressbar">\
								<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>\
							</div>\
						</div>'
				});
				c3site.popupNotify.destroy();	
			}
		},
	},
	'fs': {
		// finstat-autocomplete.js - v root _dsgn
	}
};

$(document).ready(function() {
	
	price_startstop = document.location.hash.match(/priceRange=(\d+),(\d+)/);
	if (price_startstop)
	{
		price_startstop;
		c3site.pageData.price_slider_start = price_startstop[1];
		c3site.pageData.price_slider_stop = price_startstop[2];
	}
	c3site.search.init();
	if ($('#facet').length)
	{
		$("#facet").show();
		c3site.product.filter.initialize();
	}
	
	//basic user registration
	if ($('form#register_form').length ) {
		setupRegType2();
		showFormICDPH2();
	};
	$("form#register_form select[name$='vat']").change(function(){
		showFormICDPH2();
	});
	$("form#register_form input[name$='group_name']").click(function(){
		setupRegType2();
	});
	
	
	//order process - step 2 / payment & delivery section	
	$('form#orderData input[type=radio]').change(function() {
		
		var radio = $(this);
		var name = radio.attr("name");
		
		$('form#orderData input[type=radio]').each (function() {
			$(this).prop("disabled", false)
			$(this).closest('.form-check').removeClass("disabled");
		});	
		
		if (radio.val() == "osobne" || radio.val() == "prezutie") {
			$('#payment_service_kurier_dobierka').prop("disabled", true).prop('checked', false);
			$('#payment_service_kurier_dobierka').closest('.form-check').addClass('disabled');
		} else if (radio.val() == "kurier") {
			$('#payment_service_namieste').prop("disabled", true).prop('checked', false);
			$('#payment_service_namieste').closest('.form-check').addClass('disabled');
		} else if (radio.val() == "kurier_dobierka") {
			$('#delivery_service_osobne').prop('disabled','true').prop('checked', false);
			$('#delivery_service_osobne').closest('.form-check').addClass('disabled');
		} else if (radio.val() == "namieste") {
			$('#delivery_service_kurier').prop("disabled", true).prop('checked', false);	
			$('#delivery_service_kurier').closest('.form-check').addClass('disabled');
		}
		
		checkAdditionalService();
		
	});
	
	$('form#orderData input[type=radio][name=billing_service]').change(function() {
		$('form#orderData input[type=radio][name=delivery_service]').prop("disabled", false).removeClass("ui-state-disabled");
	});
	
	//order process - step 3 / user register section
	var userRegForm = $('form#regForm');
	var regCheckTimer;
	
	if ( userRegForm.length ) {
		// hide person/company billing fields by default
		userRegForm.find('.item_FO, .item_PO').hide();
		deliveringElsewhere();
		setupRegType();
	};
	
	userRegForm.find('#reg_email').keydown(function() {
		if(event.keyCode == 13) {
			cyclone3.cancelEvent(event);
		}
    });
	
	userRegForm.find('#reg_email').keyup(function() {
		var tmpMail = $(this).val();		
		if(!tmpMail) {
			return false;
		}
		
		var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,10}(?:\.[a-z]{2})?)$/i;
		clearTimeout(regCheckTimer);
				
		$('.incorrect_email').hide();
		$('#reg_email_group .fa').hide();
		$('#loader-ico').show();
		$('#reg_email_group').removeClass('has-success has-error');
		
		regCheckTimer = setTimeout(function()
		{
			if(!re.test(tmpMail))
			{
				$('#reg_email_group').addClass('has-error');
				$('#error-ico').show();
				$('.existing_customer').hide();
				$('.incorrect_email').show();
				//$('#reg_usertype').slideUp();				
				$('#loader-ico').hide();				
				return false;
			}
			
			var checkRegistrationUrl = cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/check/registration';
			$.getJSON( checkRegistrationUrl, {
				hash: userRegForm.data('secure-hash'),
				valid: userRegForm.data('secure-valid'),
				email: tmpMail
			})
			.done(function(data) {
				try {
					if(data.result=='0') {
						$('#reg_email_group').addClass('has-error');
						$('#error-ico').show();
						$('.existing_customer').show();
						//$('#reg_usertype').slideUp();
					} else if(data.result=='1') {
						$('#reg_email_group').addClass('has-success');
						$('#success-ico').show();
						$('.existing_customer').hide();
						//$('#reg_usertype').slideDown();
					}
					previouslyChecked = tmpMail;
				}catch(e) {
					cyclone3.log('error ' + e);
				}
			})
			.fail(function( jqxhr, textStatus, error ) {
				var err = textStatus + ", " + error;
				console.log( "Request Failed: " + err );
			})
			.always(function() {
				$('#loader-ico').hide();
			});
		},1200);
    });
	
	userRegForm.find('input[name=reg_typ] + label' ).click(function() {
		$(this).prev('input[name=reg_typ] ').click(); // fix black magic label click 
	});

	userRegForm.find('input[name=reg_typ]' ).change(function() {
		setupRegType();
	});
	
	userRegForm.find('input[name=typDPH]' ).change(function() {
		deliveringElsewhere();
		showFormICDPH(userRegForm);
	});
	
	$('input[name=deliver_same]' ).change(function() {
		deliveringElsewhere();
	});
	userRegForm.find('input[name=reg_reg]' ).change(function() {
		var formReg = userRegForm.find('.form_reg');
		if(userRegForm.find('input[name="reg_reg"]:checked').val()=='true') {
			formReg.slideDown('fast');
		} else {
			formReg.slideUp('fast');
		}
	});
	
	$("#nextStep").click(function() {
		if (!$(this).hasClass("loading")) {
			//$(this).addClass("loading");
			//$(this).closest("form").submit();
		}
	});
	
	//product list remove filter
	$(document).on('click', 'a.filter_tag_remove_filter', function() { 
		var filter_name = $(this).data('filter-name');
		if (filter_name != "")
		{
			$('#facet').find("input[name='p_" + filter_name + "']").each(function() {
				if ($(this).attr('type') == "checkbox" || $(this).attr('type') == "radio") {
					$(this).prop('checked',false); 
					reset_filter_selected_text($(this));
				} else if ($(this).attr('type') == "hidden") {
					$(this).val(''); 
					if ($(this).attr('name') == "p_radius") {
						$("fieldset#p_radius li.active").removeClass("active");
						
					}
				}
			});

			// vycistenie filtrov pre rozmer a dvojrozmer
			if (filter_name == "tyre_dimension") {
				$('#facet').find('[data-filterclear="tyre_dimension"] [type="checkbox"]').each(function() {
					$(this).prop('checked',false); 
					reset_filter_selected_text($(this));
				});
			}

			c3site.product.filter.clickElemStatus = false;
			c3site.product.filter.update();
		}
	});
	
	//product list remove all filters
	$(document).on('click', 'a.clear_filter', function() { 
		{
			$('#facet').find("input").each(function() {
				if ($(this).attr('type') == "checkbox" || $(this).attr('type') == "radio") {
					$(this).prop('checked',false); 
					reset_filter_selected_text($(this));
				} else if ($(this).attr('type') == "hidden") {
					$(this).val('');
					if ($(this).attr('name') == "p_radius") {
						$("fieldset#p_radius li.active").removeClass("active");
						
					}											
				}
			});
			c3site.product.filter.clickElemStatus = false;
			c3site.product.filter.update();
			if ($('#remove_car_fitment').length) {
				console.log("cleaning");
				$('form#car_fitment_delete').submit();
			}
		}
	});
	
	//product list remove all filters
	$(document).on('click', '#reset_filter_automobil', function() { 
		{
			
			$('#facet .filter_automobil').find("input").each(function() {				
				if ($(this).attr('type') == "checkbox" || $(this).attr('type') == "radio") {
					$(this).prop('checked',false);
					reset_filter_selected_text($(this));
					
				} else if ($(this).attr('type') == "hidden") {
					$(this).val('');
					if ($(this).attr('name') == "p_radius") {
						$("fieldset#p_radius li.active").removeClass("active");						
					}											
				}
			});
			
			/* reset dvojrozmer */
			resetDvojrozmer();

			c3site.product.filter.clickElemStatus = false;
			c3site.product.filter.update();
		}
	});
	

	//product detail filter
	$(".filter-radius").click(function() {
		var input = $("#product_filters").find('input[name="radius"]');
		if ($(this).parent('li').hasClass("active")) {
			$(this).parent('li').removeClass("active");
			input.val("");
		} else {
			var filtered_radius = $(this).data('filter-radius');
			$('.filter-radius').each(function() {
				$(this).parent('li').removeClass("active");
			});
			$(this).parent('li').addClass("active");
			input.val($(this).data('filter-radius'));
		}
		processProductDetailFilters();
	});
	
	//product detail filter
	$(".filter-stock").click(function() {
		var input = $("#product_filters").find('input[name="onstock"]');
		
		if ($(this).parent('li').hasClass("active")) {
			$(this).parent('li').removeClass("active");
			input.val("0");
		} else {
			$(this).parent('li').addClass("active");
			input.val("1");
		}
		processProductDetailFilters();	
	});
	
	//product detail show admin
	$('#showAdmin').on('click', function() {
		var adminContent = $('.content-superadmin');
		// show/hide superadmin content on click
		adminContent.toggle();
		// if window width <= 768, scroll to content after click
		if($(window).width() <= 768) {
			$('html, body').animate({
				scrollTop: adminContent.offset().top - 85
			}, 500);
		}
	});
	
	//search page form sumbit
	$('#search_page_form').find('button').on('click', function() {
		$('#search_page_form').submit();
	});
	

	/* Dvojrozmer toggle */
	$(document).on('change', '#dvojrozmer-toggle', function(e) {
		if (e.target.checked) {
			document.documentElement.classList.add('dr-active');
		} else {
			document.documentElement.classList.remove('dr-active');
			resetDvojrozmerParams();
		}
	});

	function resetDvojrozmer(){
		$('#dvojrozmer-toggle').trigger('change');
	};

	function resetDvojrozmerParams(){
		$('[name="p_width_dr"]:checked').prop('checked',false);
		reset_filter_selected_text($('[name="p_width_dr"]'));
		$('[name="p_height_dr"]:checked').prop('checked',false);
		reset_filter_selected_text($('[name="p_height_dr"]'));
		$('[name="p_radius_dr"]:checked').prop('checked',false);
		reset_filter_selected_text($('[name="p_radius_dr"]'));
	};

	$(document).on('click', '#dvojrozmer-toggle, [name="p_width"], [name="p_height"], [name="p_radius"]', function(){
		if ($('[name="p_width"]:checked').length && $('[name="p_height"]:checked').length && $('[name="p_radius"]:checked').length){
			$('.f2--dvojrozmer__wrapper button').removeClass('disabled');
		} else {
			resetDvojrozmer();
			resetDvojrozmerParams();
			$('.f2--dvojrozmer__wrapper button').addClass('disabled');
		}
	});
	
});

function reset_filter_selected_text(elem) {
	var name = elem.attr('name');
	if (c3site.product.filter.text[name]) {
		elem.parents('.btn-group').find('button .selected').text(c3site.product.filter.text[name]);
	}else{
		elem.parents('.btn-group').find('button .selected').text(c3site.product.filter.text['default']);
	}
}
					
function processProductDetailFilters() {
	var radius =  $("#product_filters").find('input[name="radius"]').val();
	var onstock =  $("#product_filters").find('input[name="onstock"]').val();
	$('.product-modifications .product-list-item').each(function() {
		if (onstock == 0 || radius == "") {
			if (onstock == 0 && radius == "")
			{
				$(this).fadeIn("fast");
			}
			else if (onstock == 0)
			{
                if ($(this).data('radius') == radius) {
					$(this).fadeIn("fast");
				} else {
					$(this).fadeOut("fast");					
				}				
            }
			else
			{
				if ($(this).data('radius') == radius || $(this).data('onstock') == onstock) {
					$(this).fadeIn("fast");
				} else {
					$(this).fadeOut("fast");					
				}
			}
        }
		else
		{
			if ($(this).data('radius') == radius && $(this).data('onstock') == onstock) {
				$(this).fadeIn("fast");
			} else {
				$(this).fadeOut("fast");					
			}
		}
	});
}

function checkAdditionalService() {
	if($('input[name="delivery_service"]:checked').val()=='osobne') {
		$('#add_service_prezutie').prop("disabled", false);	
		$('#add_service_prezutie').closest('.form-check').removeClass('disabled');
	} else {
		$('#add_service_prezutie').prop("disabled", true);	
		$('#add_service_prezutie').closest('.form-check').addClass('disabled');
	}
}

function setupRegType() {
	if($('input[name="reg_typ"]:checked').val()=='PO') {
		$('.item_FO:visible').each(function() {
			$(this).slideUp('fast');
		});
		$('.item_PO:hidden').each(function() {
			$(this).slideDown('fast');
		});
		$('.form_both').slideDown('fast');
		showFormICDPH();
	} else if ($('input[name="reg_typ"]:checked').val()=='FO') {
		$('.item_PO:visible').each(function() {
			$(this).slideUp('fast');
		});
		$('.item_FO:hidden').each(function() {
			$(this).slideDown('fast');
		});
		$('.form_both').slideDown('fast');
	}
}
	
function showFormICDPH() {
	var companyICDPH = $('.company_icdph');
	var checkedTypDPH = $('input[name="typDPH"]:checked');
	
	if(checkedTypDPH.val()=='platcaDPH') {
		companyICDPH.each(function() {
			$(this).slideDown('fast');
		});			
	} else if(checkedTypDPH.val()=='neplatcaDPH') {
		companyICDPH.each(function() {
			$(this).slideUp('fast');
		});	
	} else {
		companyICDPH.each(function() {
			$(this).slideUp('fast');
		});
	}  
}
	
function setupRegType2() {
	var radio_value = $("input[name$='group_name']:checked").val();
	if(radio_value=='person') {
		$(".firm_form").fadeOut("fast");
	}
	else if(radio_value=='firm') {
		$(".firm_form").fadeIn("fast");
	}
}
function showFormICDPH2() {
	var select_value = $("select[name$='vat']").val();
	if(select_value=='platcaDPH') {
		$("input[name$='icdph']").fadeIn("fast");
	} else {
		$("input[name$='icdph']").fadeOut("fast");
	}			
}

function deliveringElsewhere()
{	
	if(!$('input[name=deliver_same]').is(':checked')) {
		if(!$('.delivering_elsewhere ').is(':visible')) {
			$('.delivering_elsewhere ').slideDown('fast'); 
		}
		$('.delivering_elsewhere _neg').slideUp('fast');
	} else {
		if($('.delivering_elsewhere ').is(':visible')) {
			$('.delivering_elsewhere ').slideUp('fast');
		}
		$('.delivering_elsewhere _neg').slideDown('fast');
	}
}

function g_addToCart(item, amount, variant){
	dataLayer.push({'ecommerce': null});	
	dataLayer.push({ 
		'event': 'add_to_cart',
		'ecommerce': {
			'currency': c3site.pageData.currencyCode,
			'value': Number(amount * $(item).data("ec-price")),
			'items': [
			{
				'item_id': $(item).data("ec-id").toString(),
				'item_name': $(item).data("ec-name"),
				'item_brand': $(item).data("ec-brand"),
				'item_variant': variant,
				'item_list_name': $(item).data("ec-list"),
				'price': Number($(item).data("ec-price")),
				'quantity': Number(amount)
			}
			]
		}
	});	
}

function g_removeFromCart(item, amount){
	dataLayer.push({'ecommerce': null});	
	dataLayer.push({ 
		'event': 'remove_from_cart',
		'ecommerce': {
			'currency': c3site.pageData.currencyCode,
			'value': Number(amount * $(item).data("ec-price")),
			'items': [
			{
				'item_id': $(item).data("ec-id").toString(),
				'item_name': $(item).data("ec-name"),
				'item_brand': $(item).data("ec-brand"),
				'item_variant': $(item).data("ec-variant"),
				'item_list_name': $(item).data("ec-list"),
				'price': Number($(item).data("ec-price")),
				'quantity': Number(amount)
			}
			]
		},
	});	
}

$(function() {
var ecService = ec.init({
    	'dataLayer': dataLayer,
    	'prefix': 'data-ec',
    	'currencyCode': 'EUR',
    	'debug': true
	})
});
